/**
 * 結帳 OTP 的判斷邏輯——唯一來源（Kiosk 結算頁與瓦斯訂購結算頁共用）。
 *
 * 以前還有一個 shouldPrefetchOtp（購物車預寄簡訊），2026-10-14 起預寄移除：
 * 結算頁的驗證卡要客戶勾協議、按「傳送驗證碼」才寄。
 */

export interface CheckoutOtpState {
  /** 後端 phone_verified === false 時為 true。 */
  needCheckoutOtp: boolean;
  /** 本次結帳是否已驗證通過。 */
  otpVerified: boolean;
}

/**
 * 是否顯示簡訊驗證區塊（驗過仍顯示，由區塊自己切換成「✓ 驗證成功」）。
 *
 * 也看 otpVerified：本次在結帳頁驗證成功後，後端會把 phone_verified 改為 true，
 * 重新整理時 Gate 取回新值 → needCheckoutOtp 變 false。若只看它，整張卡（含「✓ 驗證成功」）
 * 會突然消失，使用者以為驗證被清掉了。驗過就一直顯示成功狀態到本次結帳結束。
 */
export const shouldShowOtpCard = (s: CheckoutOtpState): boolean =>
  s.needCheckoutOtp || s.otpVerified;

/** 是否擋住「確認送出」。 */
export const shouldBlockSubmit = (s: CheckoutOtpState): boolean =>
  s.needCheckoutOtp && !s.otpVerified;
